export default function MidPageCTA() {
  return (
    <div className="bg-amber-500 py-7">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center bg-stone-950/15 rounded-full flex-shrink-0">
            <i className="ri-phone-fill text-stone-950 text-lg"></i>
          </div>
          <div>
            <p className="text-stone-950 font-extrabold text-lg leading-none">Ready to transform your floors?</p>
            <p className="text-stone-950/70 text-sm mt-0.5">Free estimates — no obligation, no pressure.</p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
          <a
            href="tel:7702361255"
            className="inline-flex items-center justify-center gap-2 bg-stone-950 hover:bg-stone-800 text-white font-bold text-sm px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            Call 770.236.1255
          </a>
          <a
            href="#estimate-form"
            className="inline-flex items-center justify-center gap-2 bg-white/25 hover:bg-white/40 text-stone-950 font-bold text-sm px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer border border-stone-950/20"
          >
            Get Free Estimate
          </a>
        </div>
      </div>
    </div>
  );
}
